import { render } from "./NcrmPrivacyInvitationAction.vue?vue&type=template&id=2ee82218&scoped=true"
import script from "./NcrmPrivacyInvitationAction.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyInvitationAction.vue?vue&type=script&lang=js"

import "./NcrmPrivacyInvitationAction.vue?vue&type=style&index=0&id=2ee82218&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee82218"]])

export default __exports__